import React from "react";
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
    actionsContainer: {
        display: 'flex',
        padding: 10
    }
}));

function checkIsLast(steps, currentStep) {
    let currentIndex = steps.findIndex(i => i.stepId === currentStep);
    return {
        isLast: currentIndex === steps.length - 1,
        isFirst: currentIndex === 0
    }
}


const SchemaDesignerActions = (props) => {
    const {changeStep, currentStep, steps, onFinish, openConfirmation, cancel, lastStep, isUpdate} = props;
    const classes = useStyles();
    const {isLast, isFirst} = checkIsLast(steps, currentStep);
    return (
        <div className={classes.actionsContainer}>
            <div style={{flexGrow: 1}}>
                <Button
                    variant={"contained"}
                    size={"small"}
                    color={"default"}
                    onClick={cancel}
                >
                    Cancel
                </Button>
                {isUpdate && (
                    <Button
                        variant={"outlined"}
                        size={"small"}
                        color={"secondary"}
                        style={{marginLeft: 5}}
                        onClick={openConfirmation}
                    >
                        Delete
                    </Button>
                )}
            </div>
            <div>
                {!isFirst && (
                    <Button
                        variant={"contained"}
                        size={"small"}
                        color={"primary"}
                        onClick={() => changeStep(currentStep - 1)}
                    >
                        Back
                    </Button>
                )}
                <Button
                    variant={"contained"}
                    size={"small"}
                    color={"primary"}
                    style={{marginLeft: 5}}
                    onClick={() => isLast ? onFinish() : changeStep(currentStep + 1)}
                >
                    {isLast ? 'Finish' : 'Next'}
                </Button>
            </div>
        </div>
    )
};
export default SchemaDesignerActions

SchemaDesignerActions.propTypes = {
    changeStep: PropTypes.func,
    onFinish: PropTypes.func,
    openConfirmation: PropTypes.func,
    cancel: PropTypes.func,
    currentStep: PropTypes.number,
    lastStep: PropTypes.number,
    isUpdate: PropTypes.bool
};